import { render, staticRenderFns } from "./Arrematante.vue?vue&type=template&id=e070f0d2&"
import script from "./Arrematante.vue?vue&type=script&lang=js&"
export * from "./Arrematante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports